import { useMemo } from 'react';

import { PermissionType } from 'api/types/entity';
import { isGlobalProject } from 'config';
import { lodash } from 'helpers';
import { TranslationPath } from 'libs/i18n';
import { ROUTES } from 'libs/navigation';
import { usePermissions } from 'libs/permissions';
import { useUser } from 'libs/providers';

interface MenuType {
  title: TranslationPath;
  path: string;
  permissions?: PermissionType[];
  isModal?: boolean;
}

const menu: MenuType[] = lodash.compact([
  {
    title: 'menu.clients',
    path: ROUTES.clients.fullPath,
    permissions: [PermissionType.Client_LegalClient_GetList],
  },
  {
    title: 'menu.orders',
    path: ROUTES.orders.fullPath,
    permissions: [PermissionType.Order_GetList],
  },
  {
    title: 'menu.operations',
    path: ROUTES.operations.fullPath,
    permissions: [PermissionType.Operation_GetList],
  },
  {
    title: 'menu.directories',
    path: ROUTES.directories.fullPath,
    permissions: [PermissionType.Directory_GetList],
  },
  isGlobalProject() && {
    title: 'menu.formFM1',
    path: ROUTES.formFM1.fullPath,
    permissions: [PermissionType.Fm1Form_Access],
  },
  {
    title: 'menu.administration',
    path: ROUTES.administration.fullPath,
    permissions: [PermissionType.SystemSetting_GetOne],
  },
]);

export const useNavigationMenu = () => {
  const { checkPermissions } = usePermissions();

  const { user } = useUser();

  const filteredMenu = useMemo(() => {
    if (!user) {
      return null;
    }

    return menu.filter((m) => {
      const permissions = m.permissions
        ? checkPermissions(m.permissions, 'or')
        : true;

      return permissions;
    });
  }, [checkPermissions, user]);

  return filteredMenu;
};
